import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M4 18h2.7a8 8 0 100-12H4a9.99 9.99 0 0118 6 10 10 0 01-18 6z"/>
    <path fill="#FF3A3A" d="M13 11H5V8l-5 4 5 4v-3h8v-2z"/>
  </SvgIcon>
);